import abi from "./NftContract.json";

export const contractAbi = abi.abi;
export const contractAddress = "0xA692643CECf2956F604aBc2277Df483b3fd78258";
